import script from "./gameCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./gameCard.vue?vue&type=script&setup=true&lang=ts"

import "./gameCard.vue?vue&type=style&index=0&id=2fb229b3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fb229b3"]])

export default __exports__